export const appDefinition =
  'Create clinically formatted & structured notes with justified coding in real time as you speak.';

export const appDefinitionCoverage =
  '(HPI, A&P, PE & CDI Billing Justified Coding & more!)';

export const newRecording = 'New Recording';

export const recordingDescriptionTitle = 'Recording exam is simple: ';

export const endingDescriptionTitle = 'Click "End Recording": ';

export const recordingDescriptionText = 'Click green "play" button to start.';

export const endingDescriptionText = 'followed by "Get Note" to create note.';

export const AIDescription = 'Our A.I. will generate your SOAP note. ';

export const AIDescriptionExtend = 'You auto-paste it into your EHR.';

export const finalSentence = 'Nothing is simpler, or more powerful.';

export const endRecording = 'End recording';

export const awaitResponseNote =
  'While our super-smart AI model is busy crafting the perfect notes from your audio, why not visit';

export const notesTitle = 'Your A.I. Co-Pilot For Medical Documentation!';

export const emptyMessage = 'Nothing to show yet.';
export const recordAudioMessage = 'Please record an audio file.';

export const uploadAudioFileMessage = `When finished, click "End Recording",
then click "Get Note" button.`;

export const errorInRecording = `Please reach out customer support.
The recording seems malformed.`;

export const awaitNote =
  'Generating notes takes almost one minute PER minute of recorded audio. Please do not close this window.';

export const scribeLink = 'ScribeBrain.AI';

export const patientNotCheckedIn = 'Patient Not Checked In.';

export const confirmMessage = 'Are you sure you want to start recording?';

export const getNote = 'Get note';

export const supportMail = 'support@scribebrain.ai';

export const contactUs = 'Contact us at: ';

export const videoError = 'Your browser does not support the video tag.';

export const warningModalTitle = 'Warning!';

export const recordingOptionModalText =
  'Please carefully pick recording option. "Over-write" will overwrite previous recording.';

export const overwriteConfirmButton = 'Over-write';

export const overwriteCancleButton = 'Continue Recording';

export const refreshPageWarning =
  'Refreshing the page will log you out. Continue?';

export const userLightNote = 'user-light-note';

const apologiesMessage = 'We apologize for the inconvenience caused.';
const customerSupportMessage =
  'Please contact our customer support team for assistance. We value your feedback and are here to assist.';
export const noteErrorMessage = `Your request may have experienced a timeout. ${apologiesMessage} ${customerSupportMessage}`;
export const authErrorMessage = 'You are not authenticated.';
export const somethingWentWrongMessage = `Oops! It seems something went wrong. ${apologiesMessage} ${customerSupportMessage}`;
export const invalidCredentialsMessage = 'Invalid credentials.';
